import { api } from "api/api";

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

const useDetalhes = () => {
  function formatarDataParaSplit(dateISO) {
    const data = new Date(dateISO);
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const ano = data.getFullYear();
    return `${dia}/${mes}/${ano}`;
  }

  async function fetchRemarcarEspecialista({ especialidadeEscolha, patient, data_atendimento }) {
    const url =
      especialidadeEscolha === '54' || especialidadeEscolha === 54
        ? `${ENDPOINT}/clients/sessaoPsicologo`
        : `${ENDPOINT}/schedule/listar-atendimentos`;

    const postsData = await api(`${url}`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ data: formatarDataParaSplit(data_atendimento), cpf: patient, especialidade: especialidadeEscolha }),
    });
    const response = await postsData.json();
    console.log('response', response);
    return response;
  }

  async function remarcarConsultaNoCalendario(atendimento) {
    window?.ReactNativeWebView?.postMessage(JSON.stringify({ calendarEvent: atendimento }));
  }

  async function sendWhatsappReagendamento(atendimento){
    await api(ENDPOINT + '/whatsapp/reagendamento', {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(atendimento),
    }).then(async(resposta) => {
      console.log("sendWhatsappReagendamento ", resposta);
    })
  }

  async function fetchRemarcarConsulta(atendimento) {
    const fetchPosts = async () => {
      try {
        await api(ENDPOINT + '/schedule/reschedule', {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'POST',
          body: JSON.stringify({
            agenda_exames_id_atual: atendimento.agenda_exames_id_atual,
            agenda_exames_id_novo: atendimento.agenda_exames_id_novo,
          }),
        }).then(async (resposta) => {
          return resposta.json();
        });
      } catch (error) {
        console.error('Error fetching posts:', error);
        console.log(error);
      }
    };

    if (atendimento.especial) {
      await fetchRemarcarEspecialista(atendimento.especialidadeEscolha, atendimento.patient, atendimento.data_atendimento).then(async (resposta) => {
        if (resposta && resposta?.agenda_exames_id > 0) {
          return;
        }
        await fetchPosts();
      });
      return;
    }
    await fetchPosts();
  }

  return {
    fetchRemarcarEspecialista,
  };
};

export default useDetalhes;
